"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueEstimationStep = void 0;
const BaseUserOnboardingStep_1 = require("../../../common/domain/BaseUserOnboardingStep");
const HlOnboardingStepId_1 = require("../HlOnboardingStepId");
const validator_1 = require("@leavy/validator");
const RevenueEstimation_1 = require("./RevenueEstimation");
class RevenueEstimationStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = HlOnboardingStepId_1.HlOnboardingStepId.HL_REVENUE_ESTIMATION;
    }
    getDataConstructor() {
        return RevenueEstimation_1.RevenueEstimation;
    }
    getDefaultData() {
        return new RevenueEstimation_1.RevenueEstimation();
    }
}
__decorate([
    (0, validator_1.Type)(() => RevenueEstimation_1.RevenueEstimation),
    __metadata("design:type", RevenueEstimation_1.RevenueEstimation)
], RevenueEstimationStep.prototype, "data", void 0);
exports.RevenueEstimationStep = RevenueEstimationStep;
//# sourceMappingURL=RevenueEstimationStep.js.map